export const LANGUAGES = ["fr", "nl"];
export const DEFAULT_LANG = "fr";

export const dict = {
  fr: {
    // Header
    "nav.home": "Accueil",
    "nav.activities": "Activités",
    "nav.families": "Pour les familles",
    "nav.agenda": "Agenda",
    "nav.about": "À propos",
    "nav.support": "Soutenir",
    "nav.contact": "Contact",
    "nav.talk": "Parler à l'équipe",
    "nav.molenbeek": "ASBL · Molenbeek",
    "nav.open_menu": "Ouvrir le menu",
    "nav.close_menu": "Fermer le menu",

    // Hero
    "hero.chip": "Molenbeek-Saint-Jean · 6–15 ans · FR / NL",
    "hero.surtitre": "Une maison pour apprendre, bouger et grandir",
    "hero.title_1": "Un lieu où votre enfant",
    "hero.title_avance": "avance",
    "hero.title_2": ". Et où votre famille se sent",
    "hero.title_comprise": "comprise",
    "hero.desc":
      "À Molenbeek, PAZAPA accueille les enfants de 6 à 15 ans et leurs familles : soutien scolaire, psychomotricité, activités éducatives, créatives et sportives, stages et sorties. On écoute votre besoin et on avance avec vous.",
    "hero.cta.find": "Trouver une activité",
    "hero.cta.talk": "Parler à l'équipe",
    "hero.cta.discover": "Découvrir PAZAPA",
    "hero.trust.since": "ASBL active depuis 2004",
    "hero.trust.jeunesse": "Association de jeunesse",
    "hero.trust.open": "Inscriptions ouvertes",
    "hero.promise": "Notre promesse",
    "hero.promise_text": "Chaque enfant avance à son rythme.",
    "hero.since": "Depuis 2004",
    "hero.visual_note": "Visuel de démonstration — à remplacer par une photo de PAZAPA",

    // Needs
    "needs.chip": "Par où commencer ?",
    "needs.title_1": "De quoi votre enfant a-t-il besoin",
    "needs.title_today": "aujourd'hui",
    "needs.subtitle":
      "Pas besoin de diagnostic. Choisissez ce qui correspond à votre situation — on vous oriente vers l'activité la plus adaptée.",
    "needs.cta": "Voir les activités",
    "needs.ecole.title": "Avancer à l'école",
    "needs.ecole.text":
      "Soutien scolaire, aide aux devoirs et méthodes pour reprendre confiance en apprentissage.",
    "needs.bouger.title": "Bouger et développer sa motricité",
    "needs.bouger.text":
      "Psychomotricité et activités sportives adaptées pour se sentir bien dans son corps.",
    "needs.lien.title": "Prendre confiance et créer du lien",
    "needs.lien.text":
      "Ateliers émotions, jeux collectifs et espaces d'échange pour se sentir accueilli.",
    "needs.creer.title": "Découvrir, créer et s'épanouir",
    "needs.creer.text":
      "Activités créatives, culturelles, stages et sorties pour éveiller la curiosité.",

    // Roadmap
    "roadmap.chip": "Plan d'action · Grandir pas à pas",
    "roadmap.title_1": "Notre",
    "roadmap.title_plan": "plan d'action",
    "roadmap.title_rest": ", étape après étape",
    "roadmap.subtitle":
      "Un accompagnement qui évolue avec les enfants et leurs familles. Chaque étape est annoncée honnêtement : ce qui est disponible aujourd'hui et ce qui arrive.",
    "roadmap.click_hint": "Cliquez sur une étape pour en savoir plus",
    "roadmap.footer": "« Un accompagnement qui évolue avec les enfants et leurs familles. »",
    "roadmap.step_1_date": "Septembre 2026",
    "roadmap.step_2_date": "Mars 2027",
    "roadmap.step_3_date": "2028",
    "roadmap.dialog_close": "Fermer",
    "roadmap.dialog_step_label": "Étape",

    // Activities
    "activities.chip": "Ce qu'on propose vraiment",
    "activities.title_our": "Nos activités",
    "activities.title_actuelles": "actuelles",
    "activities.subtitle":
      "Chaque activité affiche son statut réel. Cliquez sur « S'inscrire » pour envoyer une demande — nous vous recontactons rapidement.",
    "activities.talk_cta": "Pas sûr du choix ? Parler à l'équipe",
    "activities.register": "S'inscrire",
    "activities.soon": "Les inscriptions ouvriront prochainement.",

    // Statuses
    "status.disponible": "Disponible",
    "status.inscriptions_ouvertes": "Inscriptions ouvertes",
    "status.complet": "Complet",
    "status.liste_attente": "Liste d'attente",
    "status.bientot": "Bientôt disponible",
    "status.projet_futur": "Projet futur",

    // Life at
    "life.chip": "Un vrai lieu, pas un catalogue",
    "life.title_1": "La vie",
    "life.title_at": "chez PAZAPA",
    "life.subtitle":
      "Voilà à quoi ressemble une semaine ordinaire à Molenbeek. Concentration, mouvement, jeu, moments calmes — chacun trouve sa place.",
    "life.note":
      "Visuels de démonstration — remplacés par de vraies photos de PAZAPA, avec consentement des familles.",
    "life.cap.1": "Parcours moteur du mercredi après-midi",
    "life.cap.2": "Aide aux devoirs, 16h – 18h",
    "life.cap.3": "Atelier créatif du samedi matin",
    "life.cap.4": "Sortie de printemps au parc",
    "life.cap.5": "Un temps calme après l'activité",

    // How
    "how.chip": "Concrètement",
    "how.title": "Comment ça se passe ?",
    "how.subtitle":
      "Trois étapes simples. Sans jargon, sans questionnaire médical, sans engagement.",
    "how.step_1_title": "Vous nous expliquez votre besoin",
    "how.step_1_text":
      "Un simple message avec l'âge de votre enfant et ce que vous recherchez. Pas de dossier médical.",
    "how.step_2_title": "Nous échangeons avec vous",
    "how.step_2_text":
      "Un appel ou un e-mail dans les jours qui suivent. On écoute, on pose quelques questions.",
    "how.step_3_title": "Nous vous proposons une piste",
    "how.step_3_text":
      "Une activité, un accompagnement ou une orientation vers un partenaire — selon ce qui est disponible.",
    "how.cta": "Parler à l'équipe maintenant",

    // Events / Agenda
    "events.chip": "Agenda",
    "events.title_1": "Prochains",
    "events.title_rdv": "rendez-vous",
    "events.empty_title": "Les prochaines dates arrivent bientôt.",
    "events.empty_desc":
      "On préfère ne rien afficher plutôt qu'inventer des dates. Laissez votre e-mail : on vous prévient dès que le calendrier est publié.",
    "events.newsletter_label": "Votre e-mail",
    "events.newsletter_placeholder": "vous@exemple.be",
    "events.newsletter_cta": "Être prévenu",
    "events.newsletter_note": "Pas de spam. Uniquement les nouvelles activités et dates.",

    // Parent space
    "parents.chip": "Pour les familles",
    "parents.title_1": "Un espace aussi pour",
    "parents.title_parents": "les parents",
    "parents.subtitle":
      "Vous connaissez votre enfant. PAZAPA vous apporte un lieu, des outils et des personnes avec qui avancer.",
    "parents.note":
      "Certains programmes sont en cours de préparation. On préfère l'afficher honnêtement plutôt que de le promettre trop tôt.",
    "parents.cafes.title": "Cafés des parents",
    "parents.cafes.text": "Un moment convivial pour se rencontrer et échanger entre parents.",
    "parents.ateliers.title": "Ateliers de parentalité",
    "parents.ateliers.text": "Des outils concrets pour le quotidien, animés par des professionnels.",
    "parents.groupes.title": "Groupes de parole",
    "parents.groupes.text": "Un espace d'écoute confidentiel, sans jugement.",
    "parents.ressources.title": "Ressources pratiques",
    "parents.ressources.text": "Des fiches simples et des liens officiels pour vous accompagner.",

    // About
    "about.chip": "Qui sommes-nous",
    "about.title_1": "Une maison associative",
    "about.title_humaine": "à taille humaine",
    "about.p1":
      "PAZAPA est une ASBL de jeunesse active depuis 2004 à Molenbeek-Saint-Jean. On y accompagne des enfants aux profils variés — avec des difficultés d'apprentissage, d'attention, de motricité, de communication ou d'inclusion — et leurs familles.",
    "about.p2":
      "PAZAPA n'est ni une clinique, ni un centre de diagnostic. C'est un lieu où on apprend, on bouge, on crée, on rencontre — et où les parents trouvent une équipe qui écoute.",
    "about.v1.title": "Sans jugement",
    "about.v1.text": "Chaque enfant est accueilli comme il est, avec ou sans diagnostic.",
    "about.v2.title": "En équipe avec vous",
    "about.v2.text": "Vous connaissez votre enfant mieux que quiconque. On avance à vos côtés.",
    "about.v3.title": "Un cadre sûr",
    "about.v3.text": "Un lieu adapté, une équipe formée, des activités pensées pour se sentir bien.",

    // Support
    "support.chip": "Ensemble",
    "support.title_1": "Soutenir le lieu,",
    "support.title_manner": "à votre manière",
    "support.subtitle":
      "Trois façons simples de faire vivre PAZAPA. Aucune promesse d'équivalence chiffrée : chaque contribution est utile.",
    "support.benevole.title": "Devenir bénévole",
    "support.benevole.text":
      "Quelques heures par mois pour aider aux devoirs, animer un atelier ou soutenir la logistique.",
    "support.benevole.cta": "Nous écrire",
    "support.partner.title": "Devenir partenaire",
    "support.partner.text":
      "École, commune, entreprise, association ? Construisons ensemble un projet inclusif.",
    "support.partner.cta": "Discuter d'un partenariat",
    "support.don.title": "Faire un don",
    "support.don.text":
      "Chaque don soutient directement l'accueil des enfants à Molenbeek. Modalités précisées sur demande.",
    "support.don.cta": "Nous contacter",

    // Come
    "come.chip": "Venir à PAZAPA",
    "come.title_1": "Un vrai lieu,",
    "come.title_molenbeek": "à Molenbeek",
    "come.subtitle":
      "On accueille les familles au cœur de Molenbeek-Saint-Jean. Le mieux, c'est de nous prévenir avant de passer, pour qu'on soit disponible pour vous.",
    "come.address_label": "Adresse",
    "come.address_value": "Rue Piers 93-95-97, 1080 Molenbeek-Saint-Jean",
    "come.maps_cta": "Ouvrir l'itinéraire",
    "come.contact_label": "Contact",
    "come.contact_text":
      "Passez par le formulaire ci-dessous — on vous répond dans les 3 jours ouvrés.",
    "come.map_alt": "Carte — PAZAPA à Molenbeek",
    "come.map_note":
      "Carte OpenStreetMap. Position indicative — merci de vérifier l'adresse exacte avant votre venue.",

    // Final CTA
    "final.chip": "On avance ensemble",
    "final.title_1": "Vous ne savez pas",
    "final.title_par_ou": "par où commencer",
    "final.subtitle_1": "Expliquez-nous simplement ce que vous recherchez. On vous recontacte pour vous présenter les possibilités",
    "final.subtitle_bold": "réellement disponibles",
    "final.cta": "Parler à l'équipe",
    "final.note":
      "Ce formulaire n'est pas une évaluation clinique. On ne vous demande jamais de document médical.",

    // Footer
    "footer.tagline":
      "Une maison associative inclusive à Molenbeek. On accueille les enfants de 6 à 15 ans et leurs familles pour apprendre, bouger, créer et se sentir bien.",
    "footer.since": "ASBL active depuis 2004",
    "footer.projects": "Nos projets",
    "footer.copyright": "Tous droits réservés.",
    "footer.made": "Site pensé et écrit à Bruxelles.",
    "footer.col.explore": "Explorer",
    "footer.col.engage": "S'engager",
    "footer.col.contact": "Contact",

    // Talk form
    "talk.title": "Parler à l'équipe",
    "talk.step1_label": "Étape 1 sur 2 — Vous",
    "talk.step2_label": "Étape 2 sur 2 — Votre besoin",
    "talk.first_name": "Prénom",
    "talk.last_name": "Nom",
    "talk.email": "E-mail",
    "talk.phone": "Téléphone (facultatif)",
    "talk.commune": "Commune",
    "talk.preferred_lang": "Langue préférée",
    "talk.age": "Tranche d'âge de l'enfant *",
    "talk.need": "Besoin principal *",
    "talk.contact_pref": "Comment préférez-vous être recontacté ?",
    "talk.availability": "Vos disponibilités (facultatif)",
    "talk.avail_placeholder": "Ex : en semaine après 17h",
    "talk.consent_contact": "J'accepte que PAZAPA me recontacte.",
    "talk.consent_privacy": "J'accepte la politique de confidentialité de PAZAPA.",
    "talk.next": "Continuer",
    "talk.back": "← Retour",
    "talk.submit": "Envoyer ma demande",
    "talk.submitting": "Envoi…",
    "talk.no_medical":
      "Aucun document médical n'est demandé. Vos données sont utilisées uniquement pour vous recontacter et ne sont pas partagées.",
    "talk.success_title": "Message bien reçu.",
    "talk.success_text":
      "Un membre de l'équipe PAZAPA vous recontacte dans les 3 jours ouvrés selon la modalité choisie. Merci pour votre confiance.",
    "talk.success_back": "Retour au site",
    "talk.need.ecole": "Avancer à l'école (soutien, devoirs)",
    "talk.need.bouger": "Bouger et développer sa motricité",
    "talk.need.lien": "Prendre confiance, créer du lien",
    "talk.need.creer": "Découvrir et s'épanouir",
    "talk.need.orientation": "Je ne sais pas encore — j'aimerais qu'on en parle",
    "talk.pref.email": "E-mail",
    "talk.pref.phone": "Téléphone",
    "talk.close": "Fermer",
    "talk.errors.generic": "Une erreur est survenue. Merci de réessayer.",

    // Inscription
    "ins.title": "Inscription",
    "ins.parent_first": "Prénom du parent",
    "ins.parent_last": "Nom du parent",
    "ins.email": "E-mail",
    "ins.phone": "Téléphone (facultatif)",
    "ins.child_first": "Prénom de l'enfant (facultatif)",
    "ins.child_age": "Tranche d'âge de l'enfant *",
    "ins.availability": "Vos disponibilités (facultatif)",
    "ins.avail_placeholder": "Ex : mercredi après-midi et samedi matin",
    "ins.notes": "Un mot pour nous (facultatif)",
    "ins.notes_placeholder": "Ce que vous pensez utile qu'on sache — sans document médical.",
    "ins.consent_contact":
      "J'accepte que PAZAPA me recontacte au sujet de cette inscription.",
    "ins.consent_privacy": "J'accepte la politique de confidentialité de PAZAPA.",
    "ins.submit": "Envoyer ma demande",
    "ins.submitting": "Envoi…",
    "ins.no_medical":
      "Aucun document médical n'est demandé. Vos données sont utilisées uniquement pour vous recontacter et ne sont pas partagées.",
    "ins.success_title": "Inscription bien reçue.",
    "ins.success_text_1":
      "Merci pour votre confiance ! Un membre de l'équipe PAZAPA vous recontacte dans les 3 jours ouvrés au sujet de",
    "ins.success_back": "Retour au site",
    "ins.toast_ok": "Inscription reçue — nous vous recontactons rapidement.",

    // Newsletter
    "news.thanks": "Merci ! On vous préviendra dès la publication des prochaines dates.",

    // Age brackets (labels only — persisted value stays the FR canonical string)
    "age.6-8": "6–8 ans",
    "age.9-11": "9–11 ans",
    "age.12-15": "12–15 ans",
    "age.other": "Autre",

    // Roadmap items (details)
    "rm.ecole.title": "École des devoirs",
    "rm.ecole.desc":
      "Un accompagnement scolaire après la classe : lecture, écriture, mathématiques et méthodes de travail dans un cadre calme et bienveillant. Deux à trois après-midis par semaine à Molenbeek.",
    "rm.psy.title": "Psychomotricité",
    "rm.psy.desc":
      "Des séances en petits groupes pour développer la coordination, la motricité fine, l'attention et la confiance corporelle — animées par une psychomotricienne.",
    "rm.ateliers.title": "Ateliers éducatifs et inclusifs",
    "rm.ateliers.desc":
      "Créatif, coopératif, éducatif : des ateliers thématiques pensés pour apprendre autrement, ensemble, à son rythme. Chaque enfant a sa place.",
    "rm.prep_logo.title": "Préparation de la logopédie",
    "rm.prep_logo.desc":
      "Séances préparatoires pour amorcer un travail sur le langage, en attendant le lancement officiel de la logopédie prévu en mars 2027.",
    "rm.logo.title": "Lancement de la logopédie",
    "rm.logo.desc":
      "Prise en charge logopédique intégrée à PAZAPA : bilans, séances individuelles et travail collaboratif avec la famille et l'école. À partir de mars 2027.",
    "rm.psy_rel.title": "Psychomotricité relationnelle",
    "rm.psy_rel.desc":
      "Une approche centrée sur la relation, l'expression et le vécu corporel de l'enfant, pour dépasser certains blocages émotionnels ou de communication.",
    "rm.compo.title": "Thérapie comportementale",
    "rm.compo.desc":
      "Un accompagnement structuré pour aider les enfants à mieux réguler leurs émotions, leurs comportements et leurs relations. Encadré par un professionnel formé.",
    "rm.acc_parents.title": "Accompagnement des parents",
    "rm.acc_parents.desc":
      "Ateliers, groupes de parole et rencontres individuelles pour être soutenu, outillé et écouté dans son quotidien de parent.",
    "rm.local.title": "Nouveau local",
    "rm.local.desc":
      "Un espace plus grand et mieux adapté pour accueillir davantage d'enfants et développer les activités dans les meilleures conditions.",
    "rm.more_kids.title": "Davantage d'enfants accueillis",
    "rm.more_kids.desc":
      "Augmenter progressivement notre capacité pour répondre à la demande grandissante des familles de Molenbeek et Bruxelles.",
    "rm.equipe.title": "Équipe pluridisciplinaire",
    "rm.equipe.desc":
      "Éducateurs, logopèdes, psychomotriciens, psychologues : constituer une équipe complète autour de chaque enfant.",
    "rm.new_act.title": "Nouvelles activités",
    "rm.new_act.desc":
      "De nouveaux ateliers, sorties et projets inclusifs à imaginer avec les enfants, les familles et les partenaires du quartier.",

    // Navigation — page inclusion
    "nav.inclusion": "Inclusion à l'école",

    // Page Inclusion à l'école
    "incl.chip": "Comprendre et agir",
    "incl.title_1": "L'inclusion à l'école,",
    "incl.title_accent": "on y croit",
    "incl.subtitle":
      "Chaque enfant a sa place dans une école ordinaire. Cette page rassemble des expériences menées en Belgique, des documentaires et des ressources choisis avec soin par l'équipe PAZAPA.",
    "incl.note":
      "Contenus externes sélectionnés par PAZAPA — nous ne sommes pas à l'origine de ces productions.",
    "incl.exp.chip": "Près de chez nous",
    "incl.exp.title": "Des expériences qui inspirent à Bruxelles",
    "incl.exp.subtitle":
      "Des écoles et des associations montrent, ici en Belgique, que l'inclusion fonctionne quand elle est préparée.",
    "incl.exp.singelijn.title": "L'école Singelijn — Woluwe-Saint-Lambert",
    "incl.exp.singelijn.text":
      "Une école fondamentale ordinaire où des enfants en situation de handicap apprennent aux côtés de leurs pairs, grâce à des aménagements raisonnables et une équipe engagée.",
    "incl.exp.autre.title": "L'Autre École — Auderghem",
    "incl.exp.autre.text":
      "Une école inspirée de la pédagogie Freinet qui adapte l'enseignement aux besoins de chaque enfant, entourée de logopèdes et d'ergothérapeutes.",
    "incl.exp.vents.title": "Les 4 Vents — Bruxelles",
    "incl.exp.vents.text":
      "Une école qui accueille des enfants autistes, née d'un constat : le manque de structures adaptées et de formation des enseignants en Belgique.",
    "incl.exp.gamp.title": "GAMP & Inclusion ASBL",
    "incl.exp.gamp.text":
      "Des associations de parents qui se battent pour que chaque enfant en situation de handicap trouve sa place dans l'enseignement ordinaire — moins de 1 % y sont aujourd'hui intégrés.",
    "incl.exp.link": "Découvrir",
    "incl.docs.chip": "À regarder",
    "incl.docs.title": "Documentaires à voir en famille",
    "incl.docs.subtitle":
      "Des films belges qui donnent à voir l'inclusion telle qu'elle est — et telle qu'elle pourrait être.",
    "incl.docs.watch": "Voir la présentation",
    "incl.docs.1.title": "« L'école inclusive, l'école de tous les possibles »",
    "incl.docs.1.meta": "Matilda Ancora · 2019 · 40 min · CEFES / IN-ULB",
    "incl.docs.1.text":
      "Le quotidien de L'Autre École à Auderghem : une pédagogie qui s'adapte aux enfants, et non l'inverse.",
    "incl.docs.2.title": "« Pas si différents »",
    "incl.docs.2.meta": "Étudiants en journalisme de l'IHECS · 2026 · 26 min",
    "incl.docs.2.text":
      "Deux enfants porteurs de trisomie 21, deux parcours : l'un en école ordinaire, l'autre à l'école inclusive Singelijn.",
    "incl.docs.3.title": "« À ma place »",
    "incl.docs.3.meta": "Centre Vidéo de Bruxelles · 2021",
    "incl.docs.3.text":
      "Les associations GAMP et Inclusion dénoncent le manque criant de places pour les élèves en situation de handicap.",
    "incl.docs.4.title": "« Éclaireuses »",
    "incl.docs.4.meta": "Lydie Wisshaupt-Claudel · 2022",
    "incl.docs.4.text":
      "Une pédagogie hors des sentiers battus à Bruxelles, qui part des besoins de chaque enfant plutôt que des normes.",
    "incl.docs.5.title": "« La difficile scolarisation des enfants autistes »",
    "incl.docs.5.meta": "Reportage RTBF · 2016",
    "incl.docs.5.text":
      "Un reportage sur le manque de formations et de structures adaptées pour les enfants autistes en Belgique.",
    "incl.events.chip": "Repères",
    "incl.events.title": "Des moments pour en parler",
    "incl.events.1.title": "3 décembre — Journée internationale des personnes handicapées",
    "incl.events.1.text":
      "Chaque année, des actions et projections ont lieu partout en Belgique. Une belle occasion d'en parler en famille.",
    "incl.events.2.title": "Septembre — la rentrée, un moment charnière",
    "incl.events.2.text":
      "C'est à la rentrée que tout se joue. PAZAPA ouvre ses inscriptions en septembre pour accompagner les familles dès le départ.",
    "incl.events.note":
      "PAZAPA n'organise pas encore ses propres événements publics : quand ce sera le cas, ils seront annoncés dans l'agenda du site.",
    "incl.booklets.chip": "À emporter",
    "incl.booklets.title": "Le fascicule du mois",
    "incl.booklets.subtitle":
      "Chaque mois, l'équipe PAZAPA prépare une petite fiche pratique pour les parents. Une nouvelle édition arrive au début de chaque mois.",
    "incl.booklets.edition": "Édition n°",
    "incl.booklets.archive": "Les éditions précédentes",
    "incl.booklets.next": "Prochaine édition — en préparation",
    "incl.booklets.next_text": "Un nouveau fascicule paraît chaque mois, avec les nouveautés de l'inclusion à Bruxelles. Revenez bientôt !",
    "incl.cta.title": "Une question sur l'inclusion de votre enfant ?",
    "incl.cta.text":
      "Broby, notre petit assistant, peut déjà vous répondre — et notre équipe vous rappelle personnellement.",
    "incl.cta.broby": "Discuter avec Broby",
    "incl.cta.talk": "Parler à l'équipe",

    // Broby chatbot
    "broby.bubble": "Coucou, moi c'est Broby ! Une question ?",
    "broby.title": "Broby",
    "broby.subtitle": "Le petit assistant de PAZAPA",
    "broby.welcome":
      "Coucou ! Moi c'est Broby, le petit mouton de PAZAPA. Je peux vous expliquer qui nous sommes, nos activités, ou comment venir jusqu'à nous. Que cherchez-vous ?",
    "broby.placeholder": "Écrivez votre message…",
    "broby.send": "Envoyer",
    "broby.sug.location": "Comment venir chez vous ?",
    "broby.sug.activities": "Quelles activités pour mon enfant ?",
    "broby.sug.inscription": "Comment inscrire mon enfant ?",
    "broby.disclaimer":
      "Broby répond automatiquement. Pour votre situation personnelle, l'équipe vous répond sous 3 jours ouvrés.",
    "broby.error":
      "Oups, je n'ai pas réussi à répondre. Réessayez ou écrivez à contact@pazapaasbl.be.",
    "broby.slow":
      "Tout doux ! J'ai reçu beaucoup de messages d'un coup. Réessayez dans une petite minute.",
    "broby.open_aria": "Discuter avec Broby",
    "broby.thinking": "Broby réfléchit…",

    // FAQ publique — les questions que les parents posent à Broby
    "faq.chip": "Questions fréquentes",
    "faq.title_1": "Les questions que les parents",
    "faq.title_accent": "posent le plus à Broby",
    "faq.subtitle":
      "Voici ce que les familles nous demandent le plus souvent. Et si votre question n'y est pas, posez-la directement à Broby — il adore ça.",
    "faq.1.q": "Mon enfant n'a pas de diagnostic. Peut-il quand même venir ?",
    "faq.1.a":
      "Oui, bien sûr. Aucun diagnostic n'est demandé chez PAZAPA. Nous accueillons les enfants de 6 à 15 ans avec des difficultés d'apprentissage, d'attention, de motricité ou de communication — avec ou sans diagnostic, avec ou sans handicap.",
    "faq.2.q": "Quelles activités proposez-vous, et pour quels âges ?",
    "faq.2.a":
      "Aujourd'hui : l'école des devoirs (6-15 ans, FR/NL), la psychomotricité (6-12 ans) et des ateliers éducatifs et inclusifs (6-15 ans). La logopédie et l'accompagnement des parents arrivent en mars 2027.",
    "faq.3.q": "Comment venir jusqu'à PAZAPA ?",
    "faq.3.a":
      "Notre adresse officielle est Rue Piers 93-97 à Molenbeek, mais l'entrée se fait par l'arrière : entrez par la Maison des Cultures, Rue Mommaerts 4. Allez au fond du couloir, passez sous le préau, traversez la cour de récréation — PAZAPA est dans le bâtiment d'en face, au 3e étage, tout en haut.",
    "faq.4.q": "Comment inscrire mon enfant ?",
    "faq.4.a":
      "Cliquez sur « S'inscrire » sur l'activité qui vous intéresse, ou utilisez le formulaire « Parler à l'équipe ». Nous vous répondons sous 3 jours ouvrés, sans engagement.",
    "faq.5.q": "Les activités sont en français ou en néerlandais ?",
    "faq.5.a":
      "Les deux ! L'école des devoirs et les ateliers se font en français et en néerlandais. La psychomotricité est en français. Chaque activité du site indique sa langue.",
    "faq.6.q": "Peut-on vous rencontrer avant d'inscrire notre enfant ?",
    "faq.6.a":
      "Avec plaisir. Écrivez-nous via « Parler à l'équipe », à contact@pazapaasbl.be, ou appelez-nous (aussi sur WhatsApp) au 0489 98 71 66 : on convient d'un moment pour se rencontrer, visiter les lieux et répondre à toutes vos questions.",
    "faq.more": "Une autre question ?",
    "faq.ask": "Poser ma question à Broby",

    // Installation PWA
    "nav.install": "Installer l'application",
    "install.ios": "Sur iPhone / iPad : appuyez sur le bouton Partager de Safari, puis choisissez « Sur l'écran d'accueil ».",
    "install.generic": "Dans le menu de votre navigateur (⋮), choisissez « Installer l'application » ou « Ajouter à l'écran d'accueil ».",

    // Contact direct
    "talk.direct": "Vous préférez un contact direct ?",
    "contact.whatsapp_cta": "Écrire sur WhatsApp",
    "footer.follow": "Suivez-nous",
    "incl.booklets.print": "Imprimer",
    "incl.booklets.share": "Partager",
    "incl.booklets.copied": "Lien copié !",

    // Fil Instagram — le quotidien
    "insta.chip": "Au quotidien",
    "insta.title_1": "La vie de PAZAPA,",
    "insta.title_accent": "en images",
    "insta.subtitle":
      "Nos dernières publications Instagram — ateliers, sorties et petites victoires du quotidien.",
    "insta.soon":
      "Le fil Instagram arrive très bientôt ici. En attendant, retrouvez notre quotidien sur nos réseaux !",
    "insta.follow": "Suivre @pazapa.asbl",

    // Dons Stripe
    "don.title": "Faire un don",
    "don.subtitle": "Choisissez un montant. Paiement sécurisé via Stripe.",
    "don.custom_label": "Autre montant",
    "don.cta": "Faire mon don",
    "don.processing": "Redirection vers le paiement…",
    "don.error": "Le paiement n'a pas pu démarrer. Merci de réessayer.",
    "don.note":
      "Mode test activé pour l'instant : aucune somme réelle n'est débitée (carte de test 4242 4242 4242 4242).",
    "payment.success.title": "Merci pour votre don !",
    "payment.success.text":
      "Votre soutien fait vivre PAZAPA et l'accueil des enfants à Molenbeek. Un immense merci de la part de toute l'équipe.",
    "payment.success.pending": "Vérification du paiement en cours…",
    "payment.success.unconfirmed":
      "Si votre paiement est bien passé, nous vous en confirmerons la réception. Merci !",
    "payment.cancel.title": "Paiement annulé",
    "payment.cancel.text": "Aucun montant n'a été débité. Vous pouvez réessayer quand vous voulez.",
    "payment.back": "Retour au site",

    // Venir — accès
    "come.email_label": "E-mail",
    "come.access_title": "Comment entrer ?",
    "come.access_intro":
      "L'entrée se fait par l'arrière, via la Maison des Cultures et de la Cohésion Sociale — Rue Mommaerts 4, 1080 Molenbeek.",
    "come.access_1": "Entrez dans le bâtiment et allez au fond du couloir",
    "come.access_2": "Passez sous le préau",
    "come.access_3": "Traversez la cour de récréation",
    "come.access_4": "Bâtiment d'en face, 3e étage — tout en haut",

    // Roadmap — indice cliquable
    "roadmap.tap_bubble": "Cliquez-moi !",

    // Common
    "common.close": "Fermer",
    "common.read_more": "En savoir plus",
    "common.demo_visual_alt": "Visuel de démonstration",
  },

  nl: {
    // Header
    "nav.home": "Home",
    "nav.activities": "Activiteiten",
    "nav.families": "Voor gezinnen",
    "nav.agenda": "Agenda",
    "nav.about": "Over ons",
    "nav.support": "Steunen",
    "nav.contact": "Contact",
    "nav.talk": "Praat met het team",
    "nav.molenbeek": "VZW · Molenbeek",
    "nav.open_menu": "Menu openen",
    "nav.close_menu": "Menu sluiten",

    // Hero
    "hero.chip": "Sint-Jans-Molenbeek · 6–15 jaar · FR / NL",
    "hero.surtitre": "Een huis om te leren, te bewegen en te groeien",
    "hero.title_1": "Een plek waar uw kind",
    "hero.title_avance": "vooruitgaat",
    "hero.title_2": ". En waar uw gezin zich",
    "hero.title_comprise": "begrepen",
    "hero.desc":
      "In Molenbeek verwelkomt PAZAPA kinderen van 6 tot 15 jaar en hun gezin: huiswerkbegeleiding, psychomotoriek, educatieve, creatieve en sportieve activiteiten, stages en uitstappen. We luisteren naar uw behoefte en gaan samen vooruit.",
    "hero.cta.find": "Een activiteit vinden",
    "hero.cta.talk": "Praat met het team",
    "hero.cta.discover": "Ontdek PAZAPA",
    "hero.trust.since": "VZW actief sinds 2004",
    "hero.trust.jeunesse": "Jeugdvereniging",
    "hero.trust.open": "Inschrijvingen open",
    "hero.promise": "Onze belofte",
    "hero.promise_text": "Elk kind gaat vooruit op zijn eigen ritme.",
    "hero.since": "Sinds 2004",
    "hero.visual_note": "Voorbeeldbeeld — te vervangen door een foto van PAZAPA",

    // Needs
    "needs.chip": "Waar te beginnen?",
    "needs.title_1": "Wat heeft uw kind",
    "needs.title_today": "vandaag",
    "needs.subtitle":
      "Geen diagnose nodig. Kies wat bij uw situatie past — wij verwijzen u naar de meest geschikte activiteit.",
    "needs.cta": "Bekijk de activiteiten",
    "needs.ecole.title": "Op school vooruitgaan",
    "needs.ecole.text":
      "Huiswerkbegeleiding, ondersteuning en methodes om weer vertrouwen te krijgen in het leren.",
    "needs.bouger.title": "Bewegen en motoriek ontwikkelen",
    "needs.bouger.text":
      "Psychomotoriek en aangepaste sportactiviteiten om zich goed te voelen in zijn lichaam.",
    "needs.lien.title": "Vertrouwen krijgen en verbinding maken",
    "needs.lien.text":
      "Emotieworkshops, groepsspellen en uitwisselingsruimtes om zich welkom te voelen.",
    "needs.creer.title": "Ontdekken, creëren en bloeien",
    "needs.creer.text":
      "Creatieve, culturele activiteiten, stages en uitstappen om nieuwsgierigheid te wekken.",

    // Roadmap
    "roadmap.chip": "Actieplan · Stap voor stap groeien",
    "roadmap.title_1": "Ons",
    "roadmap.title_plan": "actieplan",
    "roadmap.title_rest": ", stap voor stap",
    "roadmap.subtitle":
      "Een begeleiding die meegroeit met de kinderen en hun gezin. Elke stap wordt eerlijk aangekondigd: wat vandaag beschikbaar is en wat eraan komt.",
    "roadmap.click_hint": "Klik op een stap voor meer info",
    "roadmap.footer": "« Een begeleiding die meegroeit met de kinderen en hun gezin. »",
    "roadmap.step_1_date": "September 2026",
    "roadmap.step_2_date": "Maart 2027",
    "roadmap.step_3_date": "2028",
    "roadmap.dialog_close": "Sluiten",
    "roadmap.dialog_step_label": "Stap",

    // Activities
    "activities.chip": "Wat we echt aanbieden",
    "activities.title_our": "Onze",
    "activities.title_actuelles": "huidige activiteiten",
    "activities.subtitle":
      "Elke activiteit toont haar werkelijke status. Klik op « Inschrijven » om een aanvraag te sturen — we nemen snel contact op.",
    "activities.talk_cta": "Niet zeker? Praat met het team",
    "activities.register": "Inschrijven",
    "activities.soon": "Inschrijvingen openen binnenkort.",

    // Statuses
    "status.disponible": "Beschikbaar",
    "status.inscriptions_ouvertes": "Inschrijvingen open",
    "status.complet": "Volzet",
    "status.liste_attente": "Wachtlijst",
    "status.bientot": "Binnenkort beschikbaar",
    "status.projet_futur": "Toekomstig project",

    // Life at
    "life.chip": "Een echte plek, geen catalogus",
    "life.title_1": "Het leven",
    "life.title_at": "bij PAZAPA",
    "life.subtitle":
      "Zo ziet een gewone week in Molenbeek eruit. Concentratie, beweging, spel, rustmomenten — iedereen vindt zijn plaats.",
    "life.note":
      "Voorbeeldbeelden — vervangen door echte foto's van PAZAPA, met toestemming van de gezinnen.",
    "life.cap.1": "Bewegingsparcours op woensdagmiddag",
    "life.cap.2": "Huiswerkbegeleiding, 16u – 18u",
    "life.cap.3": "Creatieve workshop op zaterdagochtend",
    "life.cap.4": "Voorjaarsuitstap naar het park",
    "life.cap.5": "Een rustig moment na de activiteit",

    // How
    "how.chip": "Concreet",
    "how.title": "Hoe gaat het in zijn werk?",
    "how.subtitle":
      "Drie eenvoudige stappen. Zonder jargon, zonder medische vragenlijst, zonder verplichting.",
    "how.step_1_title": "U vertelt ons wat u nodig heeft",
    "how.step_1_text":
      "Een eenvoudig bericht met de leeftijd van uw kind en wat u zoekt. Geen medisch dossier.",
    "how.step_2_title": "We gaan met u in gesprek",
    "how.step_2_text":
      "Een telefoontje of e-mail in de dagen daarop. We luisteren en stellen enkele vragen.",
    "how.step_3_title": "We stellen een piste voor",
    "how.step_3_text":
      "Een activiteit, begeleiding of doorverwijzing naar een partner — afhankelijk van wat beschikbaar is.",
    "how.cta": "Nu met het team praten",

    // Events / Agenda
    "events.chip": "Agenda",
    "events.title_1": "Volgende",
    "events.title_rdv": "afspraken",
    "events.empty_title": "De volgende data komen binnenkort.",
    "events.empty_desc":
      "We tonen liever niets dan verzonnen data. Laat uw e-mail achter: we verwittigen u zodra de kalender online staat.",
    "events.newsletter_label": "Uw e-mail",
    "events.newsletter_placeholder": "u@voorbeeld.be",
    "events.newsletter_cta": "Verwittig mij",
    "events.newsletter_note": "Geen spam. Enkel nieuwe activiteiten en data.",

    // Parent space
    "parents.chip": "Voor gezinnen",
    "parents.title_1": "Een ruimte ook voor",
    "parents.title_parents": "de ouders",
    "parents.subtitle":
      "U kent uw kind. PAZAPA brengt u een plek, tools en mensen om samen vooruit te gaan.",
    "parents.note":
      "Sommige programma's zijn in voorbereiding. We melden dit liever eerlijk dan het te vroeg te beloven.",
    "parents.cafes.title": "Oudercafés",
    "parents.cafes.text": "Een gezellig moment om andere ouders te ontmoeten en uit te wisselen.",
    "parents.ateliers.title": "Ouderworkshops",
    "parents.ateliers.text": "Concrete tools voor dagelijks gebruik, geleid door professionals.",
    "parents.groupes.title": "Gesprekgroepen",
    "parents.groupes.text": "Een vertrouwelijke luisterruimte, zonder oordeel.",
    "parents.ressources.title": "Praktische bronnen",
    "parents.ressources.text":
      "Eenvoudige fiches en officiële links om u te ondersteunen.",

    // About
    "about.chip": "Wie zijn we",
    "about.title_1": "Een sociaal huis",
    "about.title_humaine": "op mensenmaat",
    "about.p1":
      "PAZAPA is een jeugd-VZW actief sinds 2004 in Sint-Jans-Molenbeek. We begeleiden er kinderen met uiteenlopende profielen — met leer-, aandachts-, motorische, communicatie- of inclusiemoeilijkheden — en hun gezin.",
    "about.p2":
      "PAZAPA is geen kliniek en geen diagnosecentrum. Het is een plek om te leren, te bewegen, te creëren, mensen te ontmoeten — en waar ouders een luisterend team vinden.",
    "about.v1.title": "Zonder oordeel",
    "about.v1.text": "Elk kind wordt verwelkomd zoals het is, met of zonder diagnose.",
    "about.v2.title": "Samen met u",
    "about.v2.text": "U kent uw kind beter dan wie ook. We gaan aan uw zijde vooruit.",
    "about.v3.title": "Een veilig kader",
    "about.v3.text":
      "Een aangepaste plek, een opgeleid team, activiteiten die goed doen.",

    // Support
    "support.chip": "Samen",
    "support.title_1": "De plek steunen,",
    "support.title_manner": "op uw manier",
    "support.subtitle":
      "Drie eenvoudige manieren om PAZAPA te laten leven. Geen cijferbeloftes: elke bijdrage helpt.",
    "support.benevole.title": "Vrijwilliger worden",
    "support.benevole.text":
      "Enkele uren per maand om te helpen met huiswerk, een workshop te leiden of logistiek te ondersteunen.",
    "support.benevole.cta": "Ons schrijven",
    "support.partner.title": "Partner worden",
    "support.partner.text":
      "School, gemeente, bedrijf, vereniging? Laten we samen een inclusief project opbouwen.",
    "support.partner.cta": "Over een partnerschap praten",
    "support.don.title": "Doneren",
    "support.don.text":
      "Elke gift steunt rechtstreeks het onthaal van de kinderen in Molenbeek. Modaliteiten op aanvraag.",
    "support.don.cta": "Contacteer ons",

    // Come
    "come.chip": "Kom naar PAZAPA",
    "come.title_1": "Een echte plek,",
    "come.title_molenbeek": "in Molenbeek",
    "come.subtitle":
      "We verwelkomen gezinnen midden in Sint-Jans-Molenbeek. Verwittig ons het liefst vooraf, dan zijn we vrij voor u.",
    "come.address_label": "Adres",
    "come.address_value": "Piersstraat 93-95-97, 1080 Sint-Jans-Molenbeek",
    "come.maps_cta": "Route openen",
    "come.contact_label": "Contact",
    "come.contact_text":
      "Ga via het formulier hieronder — we antwoorden binnen 3 werkdagen.",
    "come.map_alt": "Kaart — PAZAPA in Molenbeek",
    "come.map_note":
      "OpenStreetMap-kaart. Positie ter indicatie — gelieve het exacte adres te controleren vóór uw bezoek.",

    // Final CTA
    "final.chip": "We gaan samen vooruit",
    "final.title_1": "Weet u niet",
    "final.title_par_ou": "waar te beginnen",
    "final.subtitle_1":
      "Vertel ons gewoon wat u zoekt. We nemen contact op om u de",
    "final.subtitle_bold": "echt beschikbare",
    "final.cta": "Praat met het team",
    "final.note":
      "Dit is geen klinische evaluatie. We vragen nooit een medisch document.",

    // Footer
    "footer.tagline":
      "Een inclusief sociaal huis in Molenbeek. We verwelkomen kinderen van 6 tot 15 jaar en hun gezin om te leren, te bewegen, te creëren en zich goed te voelen.",
    "footer.since": "VZW actief sinds 2004",
    "footer.projects": "Onze projecten",
    "footer.copyright": "Alle rechten voorbehouden.",
    "footer.made": "Site bedacht en geschreven in Brussel.",
    "footer.col.explore": "Verkennen",
    "footer.col.engage": "Betrokken raken",
    "footer.col.contact": "Contact",

    // Talk form
    "talk.title": "Praat met het team",
    "talk.step1_label": "Stap 1 van 2 — U",
    "talk.step2_label": "Stap 2 van 2 — Uw behoefte",
    "talk.first_name": "Voornaam",
    "talk.last_name": "Achternaam",
    "talk.email": "E-mail",
    "talk.phone": "Telefoon (facultatief)",
    "talk.commune": "Gemeente",
    "talk.preferred_lang": "Voorkeurstaal",
    "talk.age": "Leeftijdsgroep van het kind *",
    "talk.need": "Belangrijkste behoefte *",
    "talk.contact_pref": "Hoe wilt u gecontacteerd worden?",
    "talk.availability": "Uw beschikbaarheden (facultatief)",
    "talk.avail_placeholder": "Bv.: doordeweeks na 17u",
    "talk.consent_contact": "Ik geef PAZAPA toestemming om mij te contacteren.",
    "talk.consent_privacy": "Ik ga akkoord met het privacybeleid van PAZAPA.",
    "talk.next": "Verder",
    "talk.back": "← Terug",
    "talk.submit": "Aanvraag versturen",
    "talk.submitting": "Versturen…",
    "talk.no_medical":
      "Er wordt geen medisch document gevraagd. Uw gegevens worden enkel gebruikt om contact op te nemen en worden niet gedeeld.",
    "talk.success_title": "Bericht goed ontvangen.",
    "talk.success_text":
      "Een teamlid van PAZAPA neemt binnen 3 werkdagen contact op via de gekozen weg. Bedankt voor uw vertrouwen.",
    "talk.success_back": "Terug naar de site",
    "talk.need.ecole": "Op school vooruitgaan (steun, huiswerk)",
    "talk.need.bouger": "Bewegen en motoriek ontwikkelen",
    "talk.need.lien": "Vertrouwen en verbinding",
    "talk.need.creer": "Ontdekken en bloeien",
    "talk.need.orientation": "Ik weet het nog niet — graag samen bekijken",
    "talk.pref.email": "E-mail",
    "talk.pref.phone": "Telefoon",
    "talk.close": "Sluiten",
    "talk.errors.generic": "Er is iets misgegaan. Probeer het opnieuw.",

    // Inscription
    "ins.title": "Inschrijving",
    "ins.parent_first": "Voornaam ouder",
    "ins.parent_last": "Achternaam ouder",
    "ins.email": "E-mail",
    "ins.phone": "Telefoon (facultatief)",
    "ins.child_first": "Voornaam kind (facultatief)",
    "ins.child_age": "Leeftijdsgroep van het kind *",
    "ins.availability": "Uw beschikbaarheden (facultatief)",
    "ins.avail_placeholder": "Bv.: woensdagmiddag en zaterdagvoormiddag",
    "ins.notes": "Een woordje voor ons (facultatief)",
    "ins.notes_placeholder":
      "Wat u nuttig vindt dat we weten — zonder medisch document.",
    "ins.consent_contact":
      "Ik geef PAZAPA toestemming om mij over deze inschrijving te contacteren.",
    "ins.consent_privacy": "Ik ga akkoord met het privacybeleid van PAZAPA.",
    "ins.submit": "Aanvraag versturen",
    "ins.submitting": "Versturen…",
    "ins.no_medical":
      "Er wordt geen medisch document gevraagd. Uw gegevens worden enkel gebruikt om contact op te nemen en worden niet gedeeld.",
    "ins.success_title": "Inschrijving goed ontvangen.",
    "ins.success_text_1":
      "Bedankt voor uw vertrouwen! Een teamlid van PAZAPA neemt binnen 3 werkdagen contact met u op over",
    "ins.success_back": "Terug naar de site",
    "ins.toast_ok": "Inschrijving ontvangen — we nemen snel contact op.",

    // Newsletter
    "news.thanks":
      "Bedankt! We verwittigen u zodra de volgende data online staan.",

    // Age brackets
    "age.6-8": "6–8 jaar",
    "age.9-11": "9–11 jaar",
    "age.12-15": "12–15 jaar",
    "age.other": "Andere",

    // Roadmap items (details) — Dutch versions
    "rm.ecole.title": "Huiswerkbegeleiding",
    "rm.ecole.desc":
      "Schoolbegeleiding na de lesuren: lezen, schrijven, wiskunde en leermethoden in een rustige en warme sfeer. Twee tot drie namiddagen per week in Molenbeek.",
    "rm.psy.title": "Psychomotoriek",
    "rm.psy.desc":
      "Sessies in kleine groepen om coördinatie, fijne motoriek, aandacht en lichamelijk zelfvertrouwen te ontwikkelen — begeleid door een psychomotricus.",
    "rm.ateliers.title": "Educatieve en inclusieve workshops",
    "rm.ateliers.desc":
      "Creatief, coöperatief, educatief: thematische workshops om anders te leren, samen en op ieders tempo. Elk kind heeft zijn plaats.",
    "rm.prep_logo.title": "Voorbereiding logopedie",
    "rm.prep_logo.desc":
      "Voorbereidende sessies om aan de taal te werken, in afwachting van de officiële start van de logopedie in maart 2027.",
    "rm.logo.title": "Start van de logopedie",
    "rm.logo.desc":
      "Logopedische begeleiding geïntegreerd binnen PAZAPA: assessments, individuele sessies en samenwerking met gezin en school. Vanaf maart 2027.",
    "rm.psy_rel.title": "Relationele psychomotoriek",
    "rm.psy_rel.desc":
      "Een benadering gericht op relatie, expressie en lichaamsbeleving, om emotionele of communicatieblokkades te helpen overwinnen.",
    "rm.compo.title": "Gedragstherapie",
    "rm.compo.desc":
      "Een gestructureerde begeleiding om kinderen te helpen hun emoties, gedrag en relaties beter te reguleren. Onder begeleiding van een opgeleid professional.",
    "rm.acc_parents.title": "Ouderbegeleiding",
    "rm.acc_parents.desc":
      "Workshops, gespreksgroepen en individuele ontmoetingen om als ouder gesteund, gehoord en toegerust te worden.",
    "rm.local.title": "Nieuw pand",
    "rm.local.desc":
      "Een grotere en beter aangepaste ruimte om meer kinderen te verwelkomen en activiteiten in de beste omstandigheden aan te bieden.",
    "rm.more_kids.title": "Meer kinderen verwelkomen",
    "rm.more_kids.desc":
      "Onze capaciteit geleidelijk uitbreiden om te beantwoorden aan de groeiende vraag van gezinnen uit Molenbeek en Brussel.",
    "rm.equipe.title": "Multidisciplinair team",
    "rm.equipe.desc":
      "Opvoeders, logopedisten, psychomotrici, psychologen: een compleet team rond elk kind.",
    "rm.new_act.title": "Nieuwe activiteiten",
    "rm.new_act.desc":
      "Nieuwe workshops, uitstappen en inclusieve projecten om samen met de kinderen, gezinnen en buurtpartners te bedenken.",

    // Navigation — inclusiepagina
    "nav.inclusion": "Inclusie op school",

    // Pagina Inclusie op school
    "incl.chip": "Begrijpen en handelen",
    "incl.title_1": "Inclusie op school,",
    "incl.title_accent": "wij geloven erin",
    "incl.subtitle":
      "Elk kind heeft zijn plaats in een gewone school. Deze pagina bundelt ervaringen uit België, documentaires en zorgvuldig gekozen bronnen van het PAZAPA-team.",
    "incl.note":
      "Externe inhoud geselecteerd door PAZAPA — wij zijn niet de maker van deze producties.",
    "incl.exp.chip": "Dichtbij",
    "incl.exp.title": "Inspirerende ervaringen in Brussel",
    "incl.exp.subtitle":
      "Scholen en verenigingen tonen hier in België dat inclusie werkt wanneer ze goed voorbereid is.",
    "incl.exp.singelijn.title": "De Singelijn-school — Sint-Lambrechts-Woluwe",
    "incl.exp.singelijn.text":
      "Een gewone basisschool waar kinderen met een handicap samen leren met hun leeftijdsgenoten, dankzij redelijke aanpassingen en een betrokken team.",
    "incl.exp.autre.title": "L'Autre École — Oudergem",
    "incl.exp.autre.text":
      "Een school geïnspireerd op de Freinet-pedagogie die het onderwijs aanpast aan elk kind, omringd door logopedisten en ergotherapeuten.",
    "incl.exp.vents.title": "Les 4 Vents — Brussel",
    "incl.exp.vents.text":
      "Een school die kinderen met autisme opvangt, geboren uit een vaststelling: het gebrek aan aangepaste structuren en lerarenopleiding in België.",
    "incl.exp.gamp.title": "GAMP & Inclusion vzw",
    "incl.exp.gamp.text":
      "Ouderverenigingen die strijden zodat elk kind met een handicap zijn plaats vindt in het gewoon onderwijs — vandaag is dat minder dan 1 %.",
    "incl.exp.link": "Ontdekken",
    "incl.docs.chip": "Om te bekijken",
    "incl.docs.title": "Documentaires om als gezin te zien",
    "incl.docs.subtitle":
      "Belgische films die inclusie tonen zoals ze is — en zoals ze zou kunnen zijn.",
    "incl.docs.watch": "Bekijk de presentatie",
    "incl.docs.1.title": "« L'école inclusive, l'école de tous les possibles »",
    "incl.docs.1.meta": "Matilda Ancora · 2019 · 40 min · CEFES / IN-ULB",
    "incl.docs.1.text":
      "Het dagelijkse leven van L'Autre École in Oudergem: een pedagogie die zich aanpast aan de kinderen, en niet omgekeerd.",
    "incl.docs.2.title": "« Pas si différents »",
    "incl.docs.2.meta": "Journalistiekstudenten IHECS · 2026 · 26 min",
    "incl.docs.2.text":
      "Twee kinderen met trisomie 21, twee trajecten: één in een gewone school, één op de inclusieve Singelijn-school.",
    "incl.docs.3.title": "« À ma place »",
    "incl.docs.3.meta": "Centre Vidéo de Bruxelles · 2021",
    "incl.docs.3.text":
      "De verenigingen GAMP en Inclusion klagen het schrijnende gebrek aan plaatsen voor leerlingen met een handicap aan.",
    "incl.docs.4.title": "« Éclaireuses »",
    "incl.docs.4.meta": "Lydie Wisshaupt-Claudel · 2022",
    "incl.docs.4.text":
      "Een onorthodoxe pedagogie in Brussel, die vertrekt vanuit de noden van elk kind in plaats van de normen.",
    "incl.docs.5.title": "« La difficile scolarisation des enfants autistes »",
    "incl.docs.5.meta": "RTBF-reportage · 2016",
    "incl.docs.5.text":
      "Een reportage over het gebrek aan opleiding en aangepaste structuren voor kinderen met autisme in België.",
    "incl.events.chip": "Herdenkingen",
    "incl.events.title": "Momenten om erover te praten",
    "incl.events.1.title": "3 december — Internationale Dag van Personen met een Handicap",
    "incl.events.1.text":
      "Elk jaar vinden overal in België acties en vertoningen plaats. Een mooie gelegenheid om er thuis over te praten.",
    "incl.events.2.title": "September — de schoolstart, een sleutelmoment",
    "incl.events.2.text":
      "Bij de schoolstart wordt alles bepaald. PAZAPA opent zijn inschrijvingen in september om gezinnen van bij het begin te begeleiden.",
    "incl.events.note":
      "PAZAPA organiseert nog geen eigen publieke evenementen: zodra dat het geval is, worden ze aangekondigd in de agenda van de site.",
    "incl.booklets.chip": "Om mee te nemen",
    "incl.booklets.title": "Het boekje van de maand",
    "incl.booklets.subtitle":
      "Elke maand maakt het PAZAPA-team een praktisch fiche voor ouders. Een nieuwe editie verschijnt begin van elke maand.",
    "incl.booklets.edition": "Editie nr. ",
    "incl.booklets.archive": "Vorige edities",
    "incl.booklets.next": "Volgende editie — in voorbereiding",
    "incl.booklets.next_text": "Elke maand verschijnt een nieuw boekje met nieuws over inclusie in Brussel. Kom snel terug!",
    "incl.cta.title": "Een vraag over de inclusie van uw kind?",
    "incl.cta.text":
      "Broby, onze kleine assistent, kan u al antwoorden — en ons team neemt persoonlijk contact op.",
    "incl.cta.broby": "Praat met Broby",
    "incl.cta.talk": "Praat met het team",

    // Broby chatbot
    "broby.bubble": "Hallo, ik ben Broby! Een vraag?",
    "broby.title": "Broby",
    "broby.subtitle": "De kleine assistent van PAZAPA",
    "broby.welcome":
      "Hallo! Ik ben Broby, het kleine schaapje van PAZAPA. Ik kan u uitleggen wie we zijn, welke activiteiten we aanbieden of hoe u bij ons komt. Waar zoekt u?",
    "broby.placeholder": "Schrijf uw bericht…",
    "broby.send": "Versturen",
    "broby.sug.location": "Hoe kom ik bij jullie?",
    "broby.sug.activities": "Welke activiteiten voor mijn kind?",
    "broby.sug.inscription": "Hoe schrijf ik mijn kind in?",
    "broby.disclaimer":
      "Broby antwoordt automatisch. Voor uw persoonlijke situatie antwoordt het team binnen 3 werkdagen.",
    "broby.error":
      "Oeps, het antwoord is niet gelukt. Probeer opnieuw of mail naar contact@pazapaasbl.be.",
    "broby.slow":
      "Rustig aan! Ik kreeg veel berichten tegelijk. Probeer het over een minuutje opnieuw.",
    "broby.open_aria": "Praat met Broby",
    "broby.thinking": "Broby denkt na…",

    // Publieke FAQ — de vragen die ouders aan Broby stellen
    "faq.chip": "Veelgestelde vragen",
    "faq.title_1": "De vragen die ouders",
    "faq.title_accent": "het vaakst aan Broby stellen",
    "faq.subtitle":
      "Dit vragen gezinnen ons het vaakst. Staat uw vraag er niet bij? Stel ze rechtstreeks aan Broby — die helpt graag.",
    "faq.1.q": "Mijn kind heeft geen diagnose. Kan het toch komen?",
    "faq.1.a":
      "Ja, natuurlijk. Bij PAZAPA is geen diagnose nodig. We verwelkomen kinderen van 6 tot 15 jaar met moeilijkheden op vlak van leren, aandacht, motoriek of communicatie — met of zonder diagnose, met of zonder handicap.",
    "faq.2.q": "Welke activiteiten bieden jullie aan, en voor welke leeftijden?",
    "faq.2.a":
      "Vandaag: de huiswerkschool (6-15 jaar, FR/NL), psychomotoriek (6-12 jaar) en educatieve en inclusieve workshops (6-15 jaar). Logopedie en ouderbegeleiding starten in maart 2027.",
    "faq.3.q": "Hoe geraak ik bij PAZAPA?",
    "faq.3.a":
      "Ons officiële adres is Piersstraat 93-97 in Molenbeek, maar de ingang is achteraan: ga binnen via het Huis van Culturen, Mommaertsstraat 4. Loop door tot het einde van de gang, onder het afdak, steek de speelplaats over — PAZAPA is in het gebouw ertegenover, op de 3e verdieping, helemaal bovenaan.",
    "faq.4.q": "Hoe schrijf ik mijn kind in?",
    "faq.4.a":
      "Klik op « Inschrijven » bij de activiteit die u interesseert, of gebruik het formulier « Praat met het team ». We antwoorden binnen 3 werkdagen, vrijblijvend.",
    "faq.5.q": "Zijn de activiteiten in het Frans of het Nederlands?",
    "faq.5.a":
      "Allebei! De huiswerkschool en de workshops zijn in het Frans en het Nederlands. Psychomotoriek is in het Frans. Elke activiteit op de site vermeldt haar taal.",
    "faq.6.q": "Kunnen we jullie ontmoeten vóór we ons kind inschrijven?",
    "faq.6.a":
      "Heel graag. Schrijf ons via « Praat met het team », naar contact@pazapaasbl.be, of bel ons (ook via WhatsApp) op 0489 98 71 66: we spreken een moment af om elkaar te ontmoeten en al uw vragen te beantwoorden.",
    "faq.more": "Nog een vraag?",
    "faq.ask": "Mijn vraag aan Broby stellen",

    // PWA-installatie
    "nav.install": "App installeren",
    "install.ios": "Op iPhone / iPad: tik op de deelknop in Safari en kies « Zet op beginscherm ».",
    "install.generic": "Kies in het menu van uw browser (⋮) « App installeren » of « Toevoegen aan startscherm ».",

    // Rechtstreeks contact
    "talk.direct": "Liever rechtstreeks contact?",
    "contact.whatsapp_cta": "Stuur een WhatsApp-bericht",
    "footer.follow": "Volg ons",
    "incl.booklets.print": "Afdrukken",
    "incl.booklets.share": "Delen",
    "incl.booklets.copied": "Link gekopieerd!",

    // Instagram-feed — het dagelijks leven
    "insta.chip": "Dagelijks leven",
    "insta.title_1": "Het leven bij PAZAPA,",
    "insta.title_accent": "in beeld",
    "insta.subtitle":
      "Onze laatste Instagram-berichten — workshops, uitstappen en kleine overwinningen van elke dag.",
    "insta.soon":
      "De Instagram-feed verschijnt hier binnenkort. Volg intussen ons dagelijks leven op onze sociale netwerken!",
    "insta.follow": "Volg @pazapa.asbl",

    // Dons Stripe
    "don.title": "Doneren",
    "don.subtitle": "Kies een bedrag. Veilig betalen via Stripe.",
    "don.custom_label": "Ander bedrag",
    "don.cta": "Ik doneer",
    "don.processing": "Doorsturen naar de betaling…",
    "don.error": "De betaling kon niet starten. Probeer opnieuw.",
    "don.note":
      "Testmodus is nu actief: er wordt geen echt bedrag afgeschreven (testkaart 4242 4242 4242 4242).",
    "payment.success.title": "Bedankt voor uw gift!",
    "payment.success.text":
      "Uw steun laat PAZAPA leven en helpt de opvang van kinderen in Molenbeek. Enorm bedankt van het hele team.",
    "payment.success.pending": "Betaling wordt geverifieerd…",
    "payment.success.unconfirmed":
      "Als uw betaling is gelukt, bevestigen wij de ontvangst. Bedankt!",
    "payment.cancel.title": "Betaling geannuleerd",
    "payment.cancel.text": "Er is geen bedrag afgeschreven. U kunt opnieuw proberen wanneer u wilt.",
    "payment.back": "Terug naar de site",

    // Langs komen — toegang
    "come.email_label": "E-mail",
    "come.access_title": "Hoe binnenkomen?",
    "come.access_intro":
      "De ingang is aan de achterkant, via het Huis van de Culturen en Sociale Cohesie — Mommaertsstraat 4, 1080 Sint-Jans-Molenbeek.",
    "come.access_1": "Ga het gebouw binnen en loop tot achterin de gang",
    "come.access_2": "Loop onder de overdekte speelplaats (préau) door",
    "come.access_3": "Steek de speelplaats over",
    "come.access_4": "Gebouw aan de overkant, 3e verdieping — helemaal boven",

    // Roadmap — klikhint
    "roadmap.tap_bubble": "Klik op mij!",

    // Common
    "common.close": "Sluiten",
    "common.read_more": "Meer info",
    "common.demo_visual_alt": "Voorbeeldbeeld",
  },
};

export function translate(lang, key) {
  const src = dict[lang] || dict[DEFAULT_LANG];
  return src[key] ?? dict[DEFAULT_LANG][key] ?? key;
}
